import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";

// These commands have corresponding localisation keys for their description and arguments
const consoleCommands = [
  // Server control
  "info",
  "save",
  "QuickRestart",
  "RestartNow",
  "restart",
  "CancelRestart",
  "shutdown",
  // Players
  "Players",
  "fetchbanned",
  "kick",
  "ban",
  "unban",
  "teleport",
  "unstuck",
  "tptoplayer",
  "addtoclan",
  "kickfromclan",
  // Chat / messaging
  "admin",
  "sendadminmsgto",
  // World / time
  "season",
  "weather",
  "settime",
  "setdayspassed",
  // Spawners / multipliers
  "resetspawners",
  "suspendspawners",
  "overridezeekmulti",
  "overrideanimalmulti",
  "overridebanditmulti",
  "overridezeekrespawntime",
  "overrideanimalrespawntime",
  "overridebanditrespawntime",
  "overridexpmulti",
  "eventzombie",
  "eventbandit",
  // Player state
  "clearinfection",
  "setinfectionamount",
  "fullhealth",
  "givexp",
  "unlocktrees",
  "readallbooks",
  "forgetallbooks",
  // Quests / achievements
  "setquestreadytocomplete",
  "setquestcomplete",
  "forceresetquest",
  "incrementachievement",
  // Spawning
  "spawnitem",
  "spawnbackpack",
  "spawncar",
  "spawnai",
  // Save / data
  "fetchcardata",
  "modcarpos",
  "modsave_pos",
  "fetchplayerdata",
  "fixcar",
];

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  menu[0].items.push(commonMenuItems.console);
  return menu;
};

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "ConfSection", props: { name: "extended" } },
  { component: "HumanitZWhitelist", props: { name: "whitelist" } },
  { component: "TableSection", props: { name: "banlist" } },
  { component: "HumanitZReservedSlots", props: { name: "reserved_slots" } },
  { component: "TableSection", props: { name: "admin_list" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
  consoleCommands,
  hasActivePlayers: false,
});
